import { gql } from '@apollo/client'

export type DecisionEditPageLineItemUpdate = {
  lineNumber: number
  requestBdNetPriceAmount: number | null
  requestNetMarginPercentage: number | null
  authBdNetPriceAmount: number | null
  authNetMarginPercentage: number | null
  totalDiscountAuthPercentage?: number | null
  ogmPercentage?: never
  plCode: string
}

export type DecisionEditPageProductLineUpdate = {
  lineNumber: null
  requestBdNetPriceAmount?: never
  requestNetMarginPercentage: null
  authBdNetPriceAmount: null
  authNetMarginPercentage: null
  totalDiscountAuthPercentage?: number | null
  ogmPercentage?: number | null
  plCode: string
}

export type DecisionEditPageProductUpdate =
  | DecisionEditPageLineItemUpdate
  | DecisionEditPageProductLineUpdate

type DecisionEditPageLineUpdateRequest = {
  dealId: number
  isPLTotalView: false
  productUpdates: DecisionEditPageLineItemUpdate[]
}

type DecisionEditPageProductLineUpdateRequest = {
  dealId: number
  isPLTotalView: true
  productUpdates: DecisionEditPageProductLineUpdate[]
}

export type DecisionEditPageUpdateRequestInput = {
  updateRequest: DecisionEditPageLineUpdateRequest | DecisionEditPageProductLineUpdateRequest
}

export type UpdateDecisionEditPageLinesResponse = {
  updateDecisionEditPageLines: {
    isSuccess: boolean
    error: string | null
  }
}

export const UPDATE_DECISION_EDIT_PAGE_LINES = gql`
  mutation UpdateDecisionEditPageLines($updateRequest: DecisionEditPageUpdateRequestInput!) {
    updateDecisionEditPageLines(updateRequest: $updateRequest) {
      isSuccess
      error
    }
  }
`
